export function isThisTarget(event, parent, contextMenu) {
    if (event.target instanceof Element) {
        if (parent.contains(event.target) || parent.isSameNode(event.target)) {
            return true;
        }
        return (!!contextMenu &&
            (contextMenu.getMenu().contains(event.target) ||
                contextMenu.getMenu().isSameNode(event.target)));
    }
    return false;
}
export function hideMenuProvider(parent) {
    return (event) => {
        var _a;
        const contextMenu = (_a = parent.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-context-menu');
        if (event) {
            const composedPath = event.composedPath();
            const clickedInsideComponent = composedPath.some(el => el === parent);
            if (clickedInsideComponent) {
                return;
            }
        }
        if (contextMenu && contextMenu.opened) {
            contextMenu.hide();
        }
    };
}
